module.exports = __webpack_public_path__ + "static/media/footer_logo.487111a9.png";